import React from 'react'
import { withRouter } from 'react-router-dom'
import OcBotTestTable from './OcBotTestTable'
import OcBotTestDetail from './OcBotTestDetail'

@connect()
@boundary()
class OcBotTestContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showConversationDetail: false,
    }
  }

  componentWillMount() {
    this.renderSubPage(this.props.match.path)
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props
    if(match.path !== nextProps.match.path) {
      this.renderSubPage(nextProps.match.path, nextProps.match.params.conversationId)
    }
  }

  renderSubPage = (location, conversationId) => {
    switch (location) {
      case '/admin/ocBotTest':
        this.setState({ ...this.state, showConversationDetail: false })
        break
      case '/admin/ocBotTest/:conversationId':
        this.setState({ ...this.state, showConversationDetail: true, conversationId: conversationId || this.props.match.params.conversationId })
        break
    }
  }

  render() {
    return(
      <div>
        <h1>OC Bot Test</h1>
        { this.state.showConversationDetail ?
          <OcBotTestDetail conversationId={this.state.conversationId}/> : <OcBotTestTable/>
        }
      </div>
    )
  }
}

export default withRouter(OcBotTestContainer)
